export var OrderStatusChangeSourceEnum;
(function (OrderStatusChangeSourceEnum) {
    OrderStatusChangeSourceEnum["INTERNAL_FOOD_HALL_SERVICE"] = "INTERNAL_FOOD_HALL_SERVICE";
    OrderStatusChangeSourceEnum["INTERNAL_AUTO_STATUS_SERVICE"] = "INTERNAL_AUTO_STATUS_SERVICE";
    OrderStatusChangeSourceEnum["WEBSTORE"] = "WEBSTORE";
    OrderStatusChangeSourceEnum["DASHBOARD"] = "DASHBOARD";
    OrderStatusChangeSourceEnum["PAYMENT"] = "PAYMENT";
    OrderStatusChangeSourceEnum["VENDOR"] = "VENDOR";
})(OrderStatusChangeSourceEnum || (OrderStatusChangeSourceEnum = {}));
//# sourceMappingURL=OrderStatusChangeSourceEnum.js.map